<router-outlet></router-outlet>
<dx-load-panel
  #loadPanel
  shadingColor="rgba(0,0,0,0.1)"
  [position]="dynamicPosition || { of: '.dx-tabpanel-container' }"
  [(visible)]="loadingVisible"
  [showIndicator]="true"
  [showPane]="true"
  [shading]="true"
  [hideOnOutsideClick]="false"
>
</dx-load-panel>

<dk-error-popup></dk-error-popup>

